import React from 'react';

// Define the pages
const pages = {
  Home: 'Home',
  Apps: 'Apps',
  Focus: 'Focus',
  Timez: 'Timez',
  Qibla: 'Qibla',
  Skyki: 'Skyki',
  Todo: 'Todo',
};

// Create a default route for the Home page from pages folder
const HomeComponent = React.lazy(() => import(`../pages/Home.jsx`));

// App installs admin (same auth as /admin, different collection)
const AdminAppInstallsComponent = React.lazy(() => import(`../pages/AdminAppInstalls.jsx`));

// /Admin landing page (login + one button)
const AppzComponent = React.lazy(() => import(`../pages/Appz.jsx`));

// Old analytics/admin page
const OldDataComponent = React.lazy(() => import(`../pages/Admin.jsx`));

// UUD users data table
const UudDataComponent = React.lazy(() => import(`../pages/UudData.jsx`));

// Single presskit for all apps (Skyki, Qibla, Todo, Timez)
const AppPresskitComponent = React.lazy(() => import(`../pages/AppPresskit.jsx`));

// Create routes with dynamic imports
const pageRoutes = Object.keys(pages).map(page => {
  const Component = React.lazy(() => import(`../pages/${pages[page]}.jsx`));
  
  return {
    path: `/${page.toLowerCase()}`,
    element: <Component />,
  };
});

// Add the default route for Home
const defaultRoute = {
  path: '/',
  element: <HomeComponent />,
};

// Landing/login page
const adminTopRoute = {
  path: '/Admin',
  element: <AppzComponent />,
};

// Zilapp data (app installs page)
const zilappDataRoute = {
  path: '/ZilappData',
  element: <AdminAppInstallsComponent />,
};

// Old data page (previous analytics/admin table)
const oldDataRoute = {
  path: '/OldData',
  element: <OldDataComponent />,
};

// UUD DATA page
const uudDataRoute = {
  path: '/UudData',
  element: <UudDataComponent />,
};

// Presskit: /presskit (Skyki) and /:appSlug/presskit (qibla, todo, timez)
const presskitRoute = {
  path: '/presskit',
  element: <AppPresskitComponent />,
};

const appPresskitRoute = {
  path: '/:appSlug/presskit',
  element: <AppPresskitComponent />,
};

// Export both the default route and the dynamically generated routes
const routes = [defaultRoute, adminTopRoute, zilappDataRoute, oldDataRoute, uudDataRoute, presskitRoute, appPresskitRoute, ...pageRoutes];
export default routes;
